import $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AlerteDto } from "../../../../dto/GenApi.iNotPaie.Dto/AlerteDto";
import { NiveauAlerte } from "../../../../dto/GenApi.iNotPaie.Dto/NiveauAlerte";
import { TypeAlerte } from "../../../../dto/GenApi.iNotPaie.Dto/TypeAlerte";
import { alertesActions, isClickableAlerte } from "../../../../Helper/alertesHelper";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../../Controls/EventConstants";
import { ParametresInstance } from "../../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";

@Component({
    components: {
        ModalCardAlert: require("../../modals/modalCardAlert/modalCardAlert.vue.html")
    }
})
export default class CardAlertComponent extends Vue {
    public dataReady = false;
    public alertesFiltred: AlerteDto[] = [];
    public roles: string[] = [];
    public isAdminPst = false;
    public isUtilisateurPst = false;
    public isPayeur = false;
    public isAdmin = false;
    public niveauAlerte = NiveauAlerte;
    public alertPermissionsMap: { [key: string]: boolean } = {};

    public errorGetAlerte = false;
    public mounted(): void {
        this.isAdminPst = ParametresInstance.userHasRole(RoleConstants.AdministrateurPST);
        this.isUtilisateurPst = ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);
        this.isPayeur = ParametresInstance.userHasRole(RoleConstants.Payeur);
        this.isAdmin = ParametresInstance.userHasRole(RoleConstants.Administrateur);

        // Définie les alertes diponibles en fonction des différents rôles
        this.alertPermissionsMap = {
            [TypeAlerte.NC]: false,
            [TypeAlerte.FinPeriodeEssais]: this.isAdmin || this.isAdminPst || this.isPayeur || this.isUtilisateurPst,
            [TypeAlerte.RappelRenouvellementVisiteMedicale]: this.isAdmin || this.isAdminPst || this.isPayeur || this.isUtilisateurPst,
            [TypeAlerte.FinValiditeCarteSejour]: this.isUtilisateurPst,
            [TypeAlerte.ValidationEntreeSalarie]: this.isUtilisateurPst,
            [TypeAlerte.ClotureExercice]: this.isAdmin || this.isPayeur,
            [TypeAlerte.ClotureDSN]: this.isAdmin || this.isPayeur,
            [TypeAlerte.TauxPas]: this.isAdmin || this.isPayeur,
            [TypeAlerte.FinPrevisionnelleCDD]: this.isAdmin || this.isAdminPst || this.isPayeur || this.isUtilisateurPst,
            [TypeAlerte.DpaeARealiser]: this.isAdmin || this.isPayeur,
            [TypeAlerte.IncoherenceEffectif]: this.isAdmin || this.isAdminPst || this.isPayeur
        };

        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.fetchData();
        });

        EventBus.$on(EventConstants.RELOAD_ACCUEIL, () => {
            this.fetchData();
        });

        this.fetchData();
    }

    public fetchData(): void {
        ServicesFactoryInstance.AccueilService.getAlertes(data => {
            // Filtre les alertes en fonction des accès donnés par typeAlerteMap
            this.alertesFiltred = data
                .filter(a => Object.entries(this.alertPermissionsMap)
                    .find(([key, value]) => Number(key) == a.TypeAlerte && value));
            this.dataReady = true;
            this.errorGetAlerte = false;
        }, () => {
            this.dataReady = true;
            this.errorGetAlerte = true;
        });
    }

    public clickEvent(alerte: AlerteDto): void {
        alertesActions(alerte, this.isAdmin, this.isAdminPst, this.isPayeur, this.isUtilisateurPst);
    }

    public isClickable(alerte: AlerteDto): boolean {
        return isClickableAlerte(alerte);
    }

    public openAll(): void {
        $("#modalCardAlert").modal("show");
    }
}



// WEBPACK FOOTER //
// ./src/components/home/cards/cardAlert/cardAlert.ts